import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmailRulesServiceProvider } from '../../api/email-rules'

const EmailRulesService = EmailRulesServiceProvider()
const name = 'deleteEmailRule'

export default (id) => (asyncAction(
  name,
  EmailRulesService.deleteEmailRule,
  { id }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/email-rules/deleteEmailRule.js